import PropTypes from 'prop-types';
import React from 'react';

const FormErrorMessage = ({ text }) => (
  <div className="layout__item">
    <div className="c-label c-label--error">{ text }</div>
  </div>
  );

FormErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default FormErrorMessage;
